import { App } from 'vue'
import vClickOutside from 'click-outside-vue3'

export default function install(app: App<Element>) {
  app.use(vClickOutside)
}
